import React from 'react';
import { LucideIcon } from 'lucide-react';

interface CardHeaderProps {
  Icon: LucideIcon;
  title: string;
  iconPosition?: 'left' | 'right';
}

export function CardHeader({ Icon, title, iconPosition = 'left' }: CardHeaderProps) {
  const iconWrapper = (
    <div className="w-10 h-10 rounded-full bg-gradient-to-r from-primary to-secondary p-0.5 flex-shrink-0">
      <div className="w-full h-full rounded-full bg-white flex items-center justify-center">
        <Icon className="w-5 h-5 text-dark" />
      </div>
    </div>
  );

  return (
    <div className="flex items-start space-x-4 mb-3">
      {iconPosition === 'left' && iconWrapper}
      <h3 className="text-xl font-semibold text-gray-900 flex-1">{title}</h3>
      {iconPosition === 'right' && iconWrapper}
    </div>
  );
}